<app-spinner *ngIf="!loaded"></app-spinner>
<div class="se-app" *ngIf="loaded" ga-category="Backoffice.Memberships.Confirmation">
  <div class="se-app__main">
    <div class="se-app__content" *ngIf="membership && persona">
      <div class="se-navbar" *ngIf="prevLabel">
        <a [routerLink]="prevRoute" class="se-navbar__link">
          <se-icon name="chevron-left" size="600"></se-icon>
          {{ prevLabel }}
        </a>
      </div>
      <app-header [organization]="organization" [subtitle]="membership.membership_definition.name"></app-header>
      <div [ngClass]="{'se-app__section--border-bottom': affiliateOrganization, 'se-app__section': !affiliateOrganization}">
        <div class="se-block avatar-block">
          <se-persona-avatar
            [se-data-identity]="persona.fullName"
            [se-data-img-url]="persona.profile_image_url"
            se-data-size="300">
          </se-persona-avatar>
          <div class="titles">
            <h2 class="se-app__content-title">{{persona.first_name}}'s Membership</h2>
            <p class="se-text se-block">Member Number: {{ seMembershipCard.member.number }}</p>
          </div>
        </div>
        <div class="se-block">
          <h2 class="se-app__content-title--mb0">Thank you for joining {{ organization.name }}</h2>
          <p class="pl-text se-block" style="word-break: normal; overflow-wrap: anywhere;">Membership: {{membership.membership_definition.name}}</p>
        </div>
        <div *ngIf="membership.isRequested">
          <div class="se-block">
            <hr class="se-hr" />
          </div>
          <div class="se-block">
            <h2 class="se-app__content-title--mb0">Your membership requires review</h2>
            <p class="pl-text">It has been submitted to {{ organization.name }} and pending approval</p>
          </div>
        </div>
        <div class="se-block">
          <hr class="se-hr" />
        </div>
        <div class="se-block almost-done-block">
          <h2 class="se-app__content-title">Almost Done!</h2>
          <p class="pl-text se-block">Continue to MySportsEngine to complete additional membership requirements and save your membership card.</p>
          <div class="se-block">
            <se-button
              se-data-emphasis="high"
              se-data-is-full-width="true"
              [se-data-value]="buttonValue"
              (click)="redirect()">
            </se-button>
          </div>
        </div>
      </div>
      <div *ngIf="affiliateOrganization" class="se-app__section">
        <div class="se-block">
          <p>Do you need another membership for {{ affiliateOrganization.name }}?</p>
        </div>
        <div class="se-block">
          <se-button
            se-data-emphasis="medium"
            se-data-is-full-width="true"
            [se-data-value]="'Get Another Membership'"
            (click)="redirectToQuizzard()">
          </se-button>
        </div>
      </div>
      <app-footer
        [organization]="organization"
        [ga]="{
          orgAction: 'Organization Site - Click',
          orgLabel: membership.membership_definition.name,
          solutionsAction: 'What is SportsEngine - Click',
          solutionsLabel: membership.membership_definition.name,
          helpAction: 'SportsEngine Help Center - Click',
          helpLabel: membership.membership_definition.name
        }"></app-footer>
    </div>
  </div>
  <app-subfooter></app-subfooter>
</div>
